/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_Group_AppsInputs */

const en_portalframe_group_apps = /** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your apps`)
};

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const ar_portalframe_group_apps = en_portalframe_group_apps;

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const he_portalframe_group_apps = en_portalframe_group_apps;

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const ur_portalframe_group_apps = en_portalframe_group_apps;

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const es_portalframe_group_apps = en_portalframe_group_apps;

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const fr_portalframe_group_apps = en_portalframe_group_apps;

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const de_portalframe_group_apps = en_portalframe_group_apps;

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const pt_portalframe_group_apps = en_portalframe_group_apps;

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const hi_portalframe_group_apps = en_portalframe_group_apps;

/** @type {(inputs: Portalframe_Group_AppsInputs) => LocalizedString} */
const bn_portalframe_group_apps = en_portalframe_group_apps;

/**
* | output |
* | --- |
* | "Your apps" |
*
* @param {Portalframe_Group_AppsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_group_apps = /** @type {((inputs?: Portalframe_Group_AppsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Group_AppsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_group_apps(inputs)
	if (locale === "he") return he_portalframe_group_apps(inputs)
	if (locale === "ur") return ur_portalframe_group_apps(inputs)
	if (locale === "es") return es_portalframe_group_apps(inputs)
	if (locale === "fr") return fr_portalframe_group_apps(inputs)
	if (locale === "de") return de_portalframe_group_apps(inputs)
	if (locale === "pt") return pt_portalframe_group_apps(inputs)
	if (locale === "hi") return hi_portalframe_group_apps(inputs)
	if (locale === "bn") return bn_portalframe_group_apps(inputs)
	return /** @type {LocalizedString} */ ("Your apps")
});